import React from "react";

interface WorkflowRunViewConditionProps {
  id: string;
  content?: string;
}

export const WorkflowRunViewCondition: React.FC<
  WorkflowRunViewConditionProps
> = ({ content }) => {
  return (
    <div className="pl-11">
      <div className="text-xs text-muted-foreground bg-muted rounded px-2 py-1 inline-block">
        {content}
      </div>
    </div>
  );
};
